module.exports = __webpack_public_path__ + "img/Crinverlogo.35f3e8ec.png";